import { useState } from "react";

import Slider from "react-slick";
import AddArticle from "components/Singlearticle/AdminAction";
import GroupView from "common/Group-View/GroupViewItem";
import Blog from "common/blog/Blog";
import { pageSectionId } from "constants/constants";
import { useContext } from "react";
import WithAuthentication from "Authentication/AuthenticationContext.ts";
function ArticleContext({
  title,
  hashtags,
  files,
  description,
  bodyText,
  postId,
  singleArticle,
  setUpdater
}) {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const baseUrl = "http://grc.tatdemo.ir/";
  const auth = useContext(WithAuthentication);

  return (
    <div>
      {auth.userInfo.userType == 0 ? (
        <div
          className="text-white flex-md-row flex-column py-3 d-flex align-items-center"
          style={{ backgroundColor: "#1c2140", fontSize: "40px" }}
        >
          <div>
            <AddArticle
              postId={postId}
              setUpdater={setUpdater}
              singleArticle={singleArticle}
            ></AddArticle>
          </div>

          <div style={{ width: "60%", textAlign: "center" }}>{title}</div>
        </div>
      ) : (
        <h1
          className="text-white  py-3 d-flex align-items-center"
          style={{ backgroundColor: "#1c2140", fontSize: "40px" }}
        >
          <div style={{ width: "100%", textAlign: "center" }}>{title}</div>
        </h1>
      )}

      <div className="text-center mt-3 blog-slider-container w-100 ">
        <Slider className="" {...settings}>
          {files.map(value => {
            return (
              <div className="w-100 blog-slider-item text-center d-flex justify-content-center">
                <img
                  className=" blog-slider-image"
                  style={{ width: 200, height: 150 }}
                  src={baseUrl + value.url}
                />
              </div>
            );
          })}
        </Slider>
        {/* <img src={img1} style={{ width: "50%" }} /> */}
      </div>
      <p
        className="p-5 m-5 fw-bold fs-5"
        style={{
          borderRadius: "15px",
          backgroundColor: "lightgray",
          lineHeight: "2"
        }}
      >
        {description}
        {hashtags.length ? (
          <div style={{ fontWeight: "normal", fontSize: "14px" }}>
            برچسب ها:
            {hashtags.map(value => {
              return <span> #{value.txt} </span>;
            })}
          </div>
        ) : null}
      </p>
      <div
        className=" fs-5 fw-bold px-3"
        style={{ lineHeight: 2 }}
        dangerouslySetInnerHTML={{ __html: bodyText }}
      ></div>

      {/* {blognews.map((value, index) => {
        return <GroupView Component={Blog} numberOf={value.item.length} id={index} items={value.item} idConfig={Object.values(pageSectionId)[index + 9]} title={value.title} type={1} moreText="مطالب بیشتر"></GroupView>;
      })} */}
    </div>
  );
}
export default ArticleContext;
